import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pp-lottery-winnings" }
const _hoisted_2 = ["innerHTML"]

import { ref, computed } from "vue";
import { StringUtils } from "@sazka/utils/string-utils";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import DsDropdown from "@sazka/design-system/src/forms/components/ds-dropdown.vue";

interface WinningsSystemBetRow {
    guessedCount: number;
    minBet: number;
    maxBet: number;
    multipliers: Array<string>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-kasicka-winnings',
  setup(__props) {

const options = [
    ...Array.from({ length: 3 }, (_, index) => ({
        value: index,
        label: `SÁZKA NA ${5 - index} ${LotteryParser.getNumberLabel(5 - index).toUpperCase()}`,
    })),
    { value: 3, label: "KOMBINOVANÁ SÁZKA" },
];

const selectedOption = ref(0);

const winningsRegularBetData = [
    [
        [5, 1_000_000],
        [4, 5_000],
        [3, 300],
        [2, 40],
    ],
    [
        [4, 10_000],
        [3, 300],
        [2, 40],
        [1, 20],
    ],
    [
        [3, 2_000],
        [2, 100],
        [1, 20],
    ],
];

const isSystemBet = computed(() => selectedOption.value === options.length - 1);
const selectedRegularBetData = computed(() => (isSystemBet.value ? [] : winningsRegularBetData[selectedOption.value]));

const winningsSystemBetData: WinningsSystemBetRow[] = [
    {
        guessedCount: 6,
        minBet: 6,
        maxBet: 16,
        multipliers: ["1 080 000x", "120 000x", "10 000x", "675x", "24x"],
    },
    {
        guessedCount: 5,
        minBet: 5,
        maxBet: 16,
        multipliers: ["180 000x", "40 000x", "5 000x", "450x", "20x"],
    },
    {
        guessedCount: 4,
        minBet: 4,
        maxBet: 16,
        multipliers: ["–––", "8 000x", "2 000x", "270x", "16x"],
    },
    {
        guessedCount: 3,
        minBet: 3,
        maxBet: 16,
        multipliers: ["–––", "–––", "500x", "135x", "12x"],
    },
    {
        guessedCount: 2,
        minBet: 2,
        maxBet: 16,
        multipliers: ["–––", "–––", "–––", "45x", "8x"],
    },
    {
        guessedCount: 1,
        minBet: 1,
        maxBet: 16,
        multipliers: ["–––", "–––", "–––", "–––", "4x"],
    },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DsDropdown, {
      modelValue: selectedOption.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOption).value = $event)),
      options: options,
      id: "pp-lottery-winnings-options"
    }, null, 8, ["modelValue"]),
    (!isSystemBet.value)
      ? (_openBlock(), _createBlock(DsTable, {
          key: 0,
          class: "pp-lottery-winnings__table"
        }, {
          default: _withCtx(() => [
            _createVNode(DsRow, null, {
              default: _withCtx(() => [
                _createVNode(DsCell, {
                  type: "th",
                  class: "pp-lottery-winnings__cell"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("Uhodnuto čísel")
                  ])),
                  _: 1,
                  __: [1]
                }),
                _createVNode(DsCell, {
                  type: "th",
                  class: "pp-lottery-winnings__cell"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Výhra")
                  ])),
                  _: 1,
                  __: [2]
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedRegularBetData.value, (order, index) => {
              return (_openBlock(), _createBlock(DsRow, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(DsCell, { class: "pp-lottery-winnings__cell" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(order[0]), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(DsCell, { class: "pp-lottery-winnings__cell" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: _unref(StringUtils).formatCurrency(order[1])
                      }, null, 8, _hoisted_2)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(winningsSystemBetData, (data) => {
          return _createVNode(DsTable, {
            key: data.guessedCount,
            class: "pp-lottery-winnings__table"
          }, {
            default: _withCtx(() => [
              _createVNode(DsRow, null, {
                default: _withCtx(() => [
                  _createVNode(DsCell, {
                    type: "th",
                    colspan: "5",
                    class: "pp-lottery-winnings__cell"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", null, " Tipováno " + _toDisplayString(data.minBet) + " až " + _toDisplayString(data.maxBet) + " čísel, uhodnuto " + _toDisplayString(data.guessedCount), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(DsRow, null, {
                default: _withCtx(() => [
                  _createVNode(DsCell, {
                    type: "th",
                    colspan: "5",
                    class: "pp-lottery-winnings__cell"
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode(" Vsazené kombinace na daný počet čísel ")
                    ])),
                    _: 1,
                    __: [3]
                  })
                ]),
                _: 1
              }),
              _createVNode(DsRow, { class: "pp-lottery-winnings__row" }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                    return _createVNode(DsCell, {
                      key: n,
                      type: "th",
                      class: "pp-lottery-winnings__cell"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(6 - n), 1)
                      ]),
                      _: 2
                    }, 1024)
                  }), 64))
                ]),
                _: 1
              }),
              _createVNode(DsRow, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.multipliers, (multiplier, index) => {
                    return (_openBlock(), _createBlock(DsCell, {
                      key: index,
                      class: "pp-lottery-winnings__cell"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(multiplier), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        }), 64))
  ]))
}
}

})